import React, { useContext } from 'react';
import { Box, Optional, Wrapper } from '@honda-canada/design-system-react';

import HeaderContext from '../service/HeaderContext';
import themeStyles from '../styles/Header.styles';

const MegaMenuWrapper = themeStyles.apply(Box, 'MegaMenu');
const Container = themeStyles.apply(Wrapper, 'Container');

const MegaMenuSimple = ({ currentRef, isOpen, firstOpen, itemParams, gottenGtmTitle }) => {
  const { styles } = useContext(HeaderContext);
  const { RenderComponent, ctaLink, image, items } = itemParams;

  return (
    <Optional when={RenderComponent}>
      <MegaMenuWrapper
        data-testid="header-menu-nav-mega-menu-simple"
        ref={currentRef}
        isOpen={isOpen}
        firstOpen={firstOpen}
        $height={styles.navItemPrimary.megaMenuSimpleTopValue}
        $paddingBottom={styles.navItemPrimary.megaMenuSimplePaddingBottom}
        $paddingTop={styles.navItemPrimary.megaMenuSimplePaddingTop}
      >
        <Container px={[0, 'm', 0]}>
          <RenderComponent
            ctaLink={{ ...ctaLink, gtmTitle: 'View All' }}
            parentDisplayName={gottenGtmTitle}
            image={image}
            items={items}
          />
        </Container>
      </MegaMenuWrapper>
    </Optional>
  );
};

export default MegaMenuSimple;
